import state from './moduleVehiclesState'
import mutations from './moduleVehiclesMutations'
import actions from './moduleVehiclesActions'
import getters from './moduleVehiclesGetters'

export default {
  namespaced: true,
  state, 
  mutations,
  actions,
  getters
}